import { keyframes } from '@emotion/core';
import { styled, Typography } from '@material-ui/core';
import { createElement, FC, RefObject } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../../../theme';
import VideoScreen from '../primitive/VideoScreen';

export interface Props {
  src?: string | null;
  loop?: boolean;
  muted?: boolean;
  autoPlay?: boolean;
  controls?: boolean;
  nodownload?: boolean;
  playsInline?: boolean;
  poster?: string;
  videoRef?: RefObject<HTMLVideoElement>;
  onSeek?: (time: number) => void;
  onTimeUpdate?: (time: number) => void;
  className?: string;
  preloadAttr?: 'metadata' | 'none';
  disablePictureInPicture?: boolean;
}

const PreviewVideoScreen: FC<Props> = ({
  src,
  loop,
  muted,
  autoPlay,
  controls,
  nodownload,
  playsInline,
  poster,
  videoRef,
  onSeek,
  onTimeUpdate,
  className,
  preloadAttr,
  disablePictureInPicture,
}) => {
  let preview;
  if (src != null) {
    preview = (
      <VideoScreen
        src={src}
        loop={loop}
        muted={muted}
        autoPlay={autoPlay}
        controls={controls}
        nodownload={nodownload}
        playsInline={playsInline}
        poster={poster}
        videoRef={videoRef}
        onSeek={onSeek}
        onTimeUpdate={onTimeUpdate}
        className={className}
        preloadAttr={preloadAttr}
        disablePictureInPicture={disablePictureInPicture}
      />
    );
  } else {
    preview = (
      <Dummy className={className}>
        <Typography>
          <FormattedMessage id="show_project_page.preview_image_is_being_prepared" />
        </Typography>
      </Dummy>
    );
  }
  return preview;
};

const animation = keyframes({
  '0%': { backgroundColor: theme.palette.grey['300'] },
  '50%': { backgroundColor: theme.palette.grey['200'] },
  '100%': { backgroundColor: theme.palette.grey['300'] },
});

const Dummy = styled('div')({
  backgroundColor: theme.palette.grey['300'],
  borderRadius: 2,
  animationDuration: '1500ms',
  animationFillMode: 'forwards',
  animationIterationCount: 'infinite',
  animationName: animation,
  animationTimingFunction: 'linear',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export default PreviewVideoScreen;
